export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/header-44274a4597a19a5a5ec4c32258e04f25.jpg";